import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import lowIE from './views/LowIE.vue'
import router from './router'
import store from './store'
import Preload from './libs/preload'
import { userAgent } from 'ua_parser'
import remFix from './libs/rem'
import { Loading } from 'element-ui'
Vue.use(Loading)
Vue.prototype.remFix = remFix
Vue.use(Preload)
Vue.config.productionTip = false
var { browser } = userAgent(navigator.userAgent)
var { name, version } = browser; var { major } = version

router.beforeEach((to, from, next) => {
  if (to.name === 'home') {
    store.dispatch('changeLogo', false)
    next()
  } else {
    store.dispatch('changeLogo', true)
    next()
  }
})
new Vue({
  router,
  store,
  render: h => h(name === 'msie' && major < 10 ? lowIE : App)
}).$mount('#app')
